import { CardContainer, FormLayout, SectionHeadingSkeleton } from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading() {
  return (
    <CardContainer>
      <SectionHeadingSkeleton />

      <FormLayout>
        <div className="col-span-12 -mt-8">
          <PhoneNumberLoading />
        </div>
      </FormLayout>
    </CardContainer>
  );
}
